// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1xXgf","notes":"Notes_notes__1nAZc"};